import './Strong.css';
export var strongCSS = '_wxp4dd0-3-5-0';